import { useShowSuccess, useShowError } from 'hooks/useToast'
import { useMoveInventoryLocationToMutation } from '../../../../graphql'
import { InventoryLocation } from 'inventory-web'

import useStoreIds from 'hooks/useStoreIds'

export function updateSelectedInventoryLocations( inventoryLocationIds: string[], setInventoryLocationIds: ( ids: string[] ) => void, oldId: string, newId: string ) {
	if ( inventoryLocationIds.includes( oldId ) ) {
		setInventoryLocationIds( inventoryLocationIds.map( ( mapId ) => {
			if ( mapId === oldId ) {
				return newId
			}
			return mapId
		} ) )
	}
}

export default function useMoveInventoryLocationHandler( updateAfterMove?: ( oldInventoryLocationId: string, movedInventoryLocation: InventoryLocation, fromBranchId: number, toBranchId: number ) => void ) {
	const [ moveLocation ] = useMoveInventoryLocationToMutation()
	const showSuccess = useShowSuccess()
	const showError = useShowError()

	const { inventoryLocationIds, setInventoryLocationIds } = useStoreIds()

	return async( inventoryLocation: InventoryLocation, branchId: number ) => {
		const result = await moveLocation( { variables: {
			inventoryLocationId: inventoryLocation.id,
			branchId,
		} } )

		if ( result.data?.moveInventoryLocationTo?.success ) {
			if ( result.data.moveInventoryLocationTo.inventoryLocation ) {
				const newInventoryLocation = result.data.moveInventoryLocationTo.inventoryLocation

				updateSelectedInventoryLocations( inventoryLocationIds, setInventoryLocationIds, inventoryLocation.id, newInventoryLocation.id )
				if ( updateAfterMove ) {
					updateAfterMove( inventoryLocation.id, newInventoryLocation, inventoryLocation.branch.id, branchId )
				}
			}

			showSuccess( `moveInventoryLocationSuccess${Date.now()}`, result.data?.moveInventoryLocationTo?.message ?? 'Successfully moved store!' )
		} else {
			showError( `moveInventoryLocationError${Date.now()}`, result.data?.moveInventoryLocationTo?.message ?? 'Sorry, an error occurred' )
		}
	}
}
